import {useApi} from "../Api";
import {OWRouteDetail} from "../types/owRouteDetail";

export const useOWRouteDetailRepository = () => {
    const {GET, PUT} = useApi();

    const PATH = "/pricing/ow-route-detail";

    function getOWRouteDetails(owAncillaryId: number): Promise<OWRouteDetail[]> {
        return GET(`${PATH}/routes?owAncillaryId=${owAncillaryId}`);
    }

    function getOWRouteDetailsFromAncillary(ancillaryId: number): Promise<OWRouteDetail[]> {
        return GET(`${PATH}/routes-by-ancillary-id?ancillaryId=${ancillaryId}`);
    }

    function putOWRouteDetails(owRouteDetails: OWRouteDetail[]): Promise<OWRouteDetail[]> {
        return PUT(`${PATH}/update-routes`, owRouteDetails);
    }

    return {
        getOWRouteDetails,
        getOWRouteDetailsFromAncillary,
        putOWRouteDetails
    };
};